import { render, staticRenderFns } from "./CmgOrderConfirmation.vue?vue&type=template&id=421befe6&scoped=true&lang=pug"
import script from "./cmg-order-confirmation.ts?vue&type=script&lang=ts&external"
export * from "./cmg-order-confirmation.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgOrderConfirmation.vue?vue&type=style&index=0&id=421befe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421befe6",
  null
  
)

export default component.exports